import React from "react";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import { useLocale } from "@insightfulscience/i18";
import SmartForm from "@insightfulscience/smart-react/SmartForm";
import Button from "@insightfulscience/atomic-react/Button";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import Block from "@insightfulscience/atomic-react/Block";
import SimpleTemplateForm from "@insightfulscience/atomic-react/SimpleTemplate/Form";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Html from "@insightfulscience/smart-react/Html";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";

import routes from "@src/routes";
import { initialState, validateForm } from "./form";
import { submitEmail } from "./action";

const FreeTrialForm = () => {
	const [t] = useLocale("free-trial");

	const [action, { isLoading, error, reset }] = useFormAction(submitEmail);

	return (
		<>
			<SimpleTemplateForm>
				{isLoading && <Spinner />}
				<SmartForm textRender={t} {...{ initialState, validateForm, action }} onTouched={reset}>
					<SmartForm.Field
						label="EMAIL"
						name="email"
						type="email"
						disabled={isLoading}
						error={error}
						fieldClassName="mb-8"
						required
						data-qa-selector="free-trial-email-input"
					/>
					<Row>
						<Col spacing={{ mt: 4, mb: 2 }}>
							<Block sx={{ textAlign: "center" }}>
								<Button
									type="submit"
									disabled={isLoading}
									data-qa-selector="free-trial-submit-button"
								>
									{t("SUBMIT")}
								</Button>
							</Block>
						</Col>
					</Row>
				</SmartForm>
			</SimpleTemplateForm>
			<Paragraph sx={{ fontSize: "xs", textAlign: "center" }}>
				<Html Tag="span">
					{t("AGREEMENT", {
						tosLink: routes.external.termsOfService,
						ppLink: routes.external.privacyPolicy,
					})}
				</Html>
			</Paragraph>
		</>
	);
};

export default FreeTrialForm;
